import Modal from "components/Modal/Modal";
import { BOOKMARK_LISTNAME_MAX_LENGTH } from "constants/config";
import { useBookmarks } from "features/Bookmarks";
import { IBookmarkListItem } from "helpers/bookmark";
import useLabels from "hooks/useLabels";
import { useEffect, useState } from "react";

type EditListModalProps = {
  bookmarkList: IBookmarkListItem;
  onClose: () => void;
  open?: boolean;
};

function EditListModal({ open, onClose, bookmarkList }: EditListModalProps) {
  const [modalLabels] = useLabels("edit-list-modal");
  const { updateBookmarkListName } = useBookmarks();

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(bookmarkList?.text_label ?? "");
  }, [bookmarkList?.text_label]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handleSaveClicked = async () => {
    let newLabel = inputValue.trim();

    if (newLabel !== bookmarkList.text_label) {
      await updateBookmarkListName(bookmarkList.id, newLabel);
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={modalLabels["title"]}
      onButtonClicked={handleSaveClicked}
      buttonText={modalLabels["save"]}
      buttonDisabled={inputValue.trim().length === 0}
    >
      <div className="flex flex-col gap-2 text-fg-base">
        <h2 className="base-bold">{modalLabels["list-name"]}</h2>
        <input
          value={inputValue}
          placeholder={modalLabels["name"]}
          onChange={handleInputChange}
          className="p-4 border rounded-lg"
        />
        <span className="tiny-normal text-fg-muted">
          {modalLabels["maximum-characters"].replace(
            "{max-value}",
            BOOKMARK_LISTNAME_MAX_LENGTH
          )}
        </span>
      </div>
    </Modal>
  );
}

export default EditListModal;
